/**
 * Canonical Wanderu app-store links, matching the rest of Nexus
 * (`src/components/c2c/download-the-app.tsx`). There is no `wanderu.com/app`
 * smart link in the app today; these are the real store URLs, campaign-tagged
 * for this landing page.
 *
 * TODO(growth): confirm the campaign tag before go-live.
 */
const CAMPAIGN = 'america250-landing'

export const APP_STORE_URL = `https://apps.apple.com/app/apple-store/id962532589?ct=${CAMPAIGN}&mt=8&pt=117125988`
export const PLAY_STORE_URL = `https://play.google.com/store/apps/details?id=com.wanderu.wanderu&utm_campaign=${CAMPAIGN}&utm_source=web`
